export default [
  {
    path: '/pedidos',
    name: 'pedidos',
    component: () => import(/* webpackChunkName: "pedidos" */ '../../views/pedidos/Pedidos')
  }
]
